<template>
    <v-footer dark padless height="auto" inset app>
        <v-card class="flex" flat tile>
            <v-card-actions class="grey darken-3 justify-center">
                &copy;{{yearCr}} — <strong>{{nameCr}}</strong>
            </v-card-actions>
        </v-card>
    </v-footer>
</template>

<script>
export default {
    name: "Footer",
    props: {
        yearCr: String,
        nameCr: String,
    },
}
</script>

<style>
</style>
